import { useEffect, useState } from "react";
import api from "../lib/api";
import { Flame, Calendar } from "lucide-react";

export default function WeeklySpecial() {
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/offers/active")
      .then((r) => setOffer(r.data))
      .catch(() => setOffer(null))
      .finally(() => setLoading(false));
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  const fallback = {
    title: "Chef's Nepalese Lamb Curry",
    description: "Slow-cooked for two hours with Himalayan salt, garam masala and bay leaf. Served with turmeric basmati rice and freshly baked paratha.",
    price: "€18.50",
    image_url: "/images/g3.jpg",
  };
  const display = offer || fallback;

  return (
    <section
      id="offer"
      data-testid="weekly-special-section"
      className="relative py-20 sm:py-28 grain"
      style={{ background: "linear-gradient(180deg, #FAF4F1 0%, #F0EAE6 100%)" }}
    >
      <div className="container-wide">
        <div className="reveal flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="eyebrow flex items-center gap-2"><Flame size={14}/> This Week Only</div>
            <h2 className="section-title text-4xl sm:text-5xl mt-3">Weekly Special</h2>
          </div>
          <p className="text-[#4A5568] max-w-md text-base sm:text-lg">A handpicked dish from our chef. Fresh ingredients, made-to-order, available all week.</p>
        </div>

        <div className="reveal relative grid md:grid-cols-2 bg-white rounded-3xl overflow-hidden shadow-2xl shadow-[#5979A9]/10 border border-[#F0EAE6]" data-testid="weekly-special-card">
          <div className="absolute top-5 right-5 z-10 inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-[#E05947] text-white text-[11px] tracking-[0.18em] uppercase font-bold shadow-lg">
            <Flame size={12}/> Chef's Pick
          </div>
          <div className="aspect-[4/3] md:aspect-auto md:min-h-[420px]">
            <img
              src={display.image_url}
              alt={display.title}
              className="w-full h-full object-cover"
              data-testid="weekly-special-image"
            />
          </div>
          <div className="p-8 sm:p-12 flex flex-col justify-center">
            <span className="eyebrow mb-3">Featured this week</span>
            <h3 className="font-serif-display text-3xl sm:text-4xl text-[#5979A9] mb-4 leading-tight" data-testid="weekly-special-title">
              {display.title}
            </h3>
            <p className="text-[#4A5568] text-base sm:text-lg leading-relaxed mb-6" data-testid="weekly-special-description">
              {display.description}
            </p>
            <div className="flex items-end justify-between mb-8">
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#5979A9]/70 mb-1">Today's Price</div>
                <div className="font-serif-display text-5xl text-[#E05947]" data-testid="weekly-special-price">{display.price}</div>
              </div>
              <span className="text-xs text-[#5979A9]/60 italic">while it lasts</span>
            </div>
            <button onClick={() => scrollTo("contact")} data-testid="weekly-special-book-button" className="btn-primary self-start">
              <Calendar size={16}/> Book a Table
            </button>
          </div>
        </div>

        {loading && <p className="text-center text-sm text-[#5979A9]/60 mt-6">Loading this week's special…</p>}
      </div>
    </section>
  );
}
